// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/admin/styles/adminCampDetails.css
 * Design tokens + small custom classes for the Camp Financial Detail page.
 * Shares the same token names as adminDashboard.css so both can be
 * imported independently without producing conflicting values.
 */

:root {
  --admin-primary: #11a8a4;
  --admin-primary-dark: #0d8f8c;
  --admin-primary-light: #e8f8f7;
  --admin-background: #f5f7f8;
  --admin-card: #ffffff;
  --admin-text: #172b2b;
  --admin-muted: #6b7c7c;
  --admin-border: #e2e8e8;
  --admin-success: #10b981;
  --admin-warning: #d97706;
  --admin-danger: #dc2626;
}

.admin-camp-details-page {
  background-color: var(--admin-background);
  color: var(--admin-text);
}

/* Vertical cost breakdown list */
.admin-cost-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 0;
  border-bottom: 1px solid var(--admin-border);
}

.admin-cost-row:last-of-type {
  border-bottom: none;
}

.admin-cost-row.total {
  border-top: 2px solid var(--admin-text);
  margin-top: 0.25rem;
  padding-top: 0.85rem;
  font-weight: 700;
}

/* Profit margin visual bar */
.admin-margin-track {
  position: relative;
  width: 100%;
  height: 10px;
  border-radius: 9999px;
  background-color: var(--admin-border);
  overflow: hidden;
}

.admin-margin-fill {
  position: absolute;
  inset: 0;
  border-radius: 9999px;
  background-color: var(--admin-primary);
  transition: width 0.4s ease;
}

/* Profit equation row (Billing - Cost = Profit) */
.admin-equation-operator {
  color: var(--admin-muted);
  font-weight: 700;
  font-size: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Admin_dashboard/adminCampDetails.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* src/admin/styles/adminCampDetails.css\r\n * Design tokens + small custom classes for the Camp Financial Detail page.\r\n * Shares the same token names as adminDashboard.css so both can be\r\n * imported independently without producing conflicting values.\r\n */\r\n\r\n:root {\r\n  --admin-primary: #11a8a4;\r\n  --admin-primary-dark: #0d8f8c;\r\n  --admin-primary-light: #e8f8f7;\r\n  --admin-background: #f5f7f8;\r\n  --admin-card: #ffffff;\r\n  --admin-text: #172b2b;\r\n  --admin-muted: #6b7c7c;\r\n  --admin-border: #e2e8e8;\r\n  --admin-success: #10b981;\r\n  --admin-warning: #d97706;\r\n  --admin-danger: #dc2626;\r\n}\r\n\r\n.admin-camp-details-page {\r\n  background-color: var(--admin-background);\r\n  color: var(--admin-text);\r\n}\r\n\r\n/* Vertical cost breakdown list */\r\n.admin-cost-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0.65rem 0;\r\n  border-bottom: 1px solid var(--admin-border);\r\n}\r\n\r\n.admin-cost-row:last-of-type {\r\n  border-bottom: none;\r\n}\r\n\r\n.admin-cost-row.total {\r\n  border-top: 2px solid var(--admin-text);\r\n  margin-top: 0.25rem;\r\n  padding-top: 0.85rem;\r\n  font-weight: 700;\r\n}\r\n\r\n/* Profit margin visual bar */\r\n.admin-margin-track {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 10px;\r\n  border-radius: 9999px;\r\n  background-color: var(--admin-border);\r\n  overflow: hidden;\r\n}\r\n\r\n.admin-margin-fill {\r\n  position: absolute;\r\n  inset: 0;\r\n  border-radius: 9999px;\r\n  background-color: var(--admin-primary);\r\n  transition: width 0.4s ease;\r\n}\r\n\r\n/* Profit equation row (Billing - Cost = Profit) */\r\n.admin-equation-operator {\r\n  color: var(--admin-muted);\r\n  font-weight: 700;\r\n  font-size: 1.25rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
